import React from 'react';

import { createPortal } from 'react-dom';

import { Container, StyledWrapper } from './styles';

interface ILoaderProps {
  isVisible: boolean;
}

const LoaderAtomic: React.FC<ILoaderProps> = ({ isVisible }) => {

  return (
    <>
      {createPortal(
        <Container isVisible={isVisible}>
          <StyledWrapper>
            <div className="loader">
              <div className="react-star">
                <div className="nucleus" />
                <div className="electron electron1" />
                <div className="electron electron2" />
                <div className="electron electron3" />
              </div>
            </div>
          </StyledWrapper>
        </Container>,
         document.getElementById('portal-loader') as HTMLElement
      )}
    </>
  );
}

export default LoaderAtomic;
